import {
    CONSTANT_VACCINATION_ID_KEY,
    EXPANDED_WOLBACHIA_ID_KEY,
    FORECAST_SCENARIO_ID_KEY,
} from '@portal/common/models/data-key';
import { TakedaDengueRecords } from '@portal/common/models/data-type';
import { DataRecord, DataResponse, DataType } from '@portal/common/types';

import { FORECAST_SCENARIO_SPLIT_MAP } from '../../constants/dengue-scenarios';

/**
 * Patches dengue data by adding constant vaccination and expanded Wolbachia columns
 * @param responseByDataTypes - patched data response organized by data types
 */
const patchDengueData = (responseByDataTypes: Record<DataType, DataResponse>) => {
    const { columns, records } = responseByDataTypes[TakedaDengueRecords];

    const newColumns = [...columns, CONSTANT_VACCINATION_ID_KEY, EXPANDED_WOLBACHIA_ID_KEY];

    const forecastScenarioIdx = columns.indexOf(FORECAST_SCENARIO_ID_KEY);

    const newRecords = records.map((record: DataRecord): DataRecord => {
        const forecastScenarioId = record[forecastScenarioIdx];
        const constantVaccination =
            FORECAST_SCENARIO_SPLIT_MAP[forecastScenarioId]?.[CONSTANT_VACCINATION_ID_KEY];
        const expandedWolbachia =
            FORECAST_SCENARIO_SPLIT_MAP[forecastScenarioId]?.[EXPANDED_WOLBACHIA_ID_KEY];
        return [...record, constantVaccination, expandedWolbachia];
    });

    responseByDataTypes[TakedaDengueRecords] = { columns: newColumns, records: newRecords };
};

export default patchDengueData;
